import React, { useRef } from 'react';
import { useMap } from 'react-leaflet';
import { FaLocationArrow, FaMapLocationDot, FaStreetView } from 'react-icons/fa6';
import L from 'leaflet';

// Map control components - EXACT same from original Onde.jsx
function CurrentLocationButton() {
  const map = useMap();
  const markerRef = useRef(null);

  const handleClick = () => {
    if (!navigator.geolocation) {
      alert("Geolocation is not supported by your browser.");
      return;
    }

    navigator.geolocation.getCurrentPosition(
      (position) => {
        const { latitude, longitude } = position.coords;
        map.flyTo([latitude, longitude], 18);

        if (markerRef.current) {
          map.removeLayer(markerRef.current);
        }

        const icon = L.icon({
          iconUrl: require("leaflet/dist/images/marker-icon.png"),
          iconRetinaUrl: require("leaflet/dist/images/marker-icon-2x.png"),
          shadowUrl: require("leaflet/dist/images/marker-shadow.png"),
          iconSize: [25, 41],
          iconAnchor: [12, 41],
          popupAnchor: [1, -34],
          shadowSize: [41, 41],
        });

        const newMarker = L.marker([latitude, longitude], { icon })
          .addTo(map)
          .bindPopup("You are here")
          .openPopup();

        markerRef.current = newMarker;
      },
      (error) => {
        console.error("Error getting location:", error);
        alert("Unable to get your location.");
      }
    );
  };

  return (
    <button onClick={handleClick} title="Go to my location" className="onde-location-button">
      <FaLocationArrow size={18} />
    </button>
  );
}

function ZoomButtons() {
  const map = useMap();

  return (
    <div className="onde-zoom-buttons-container">
      <button onClick={() => map.zoomIn()} title="Zoom in" className="onde-zoom-button">
        +
      </button>
      <button onClick={() => map.zoomOut()} title="Zoom out" className="onde-zoom-button">
        -
      </button>
    </div>
  );
}

function ViewToggleButton({ mode, onToggle }) {
  const title = mode === "map" ? "Switch to Satellite View" : "Switch to Map View";

  return (
    <button onClick={onToggle} title={title} className="onde-view-toggle-button">
      {mode === "map" && <FaMapLocationDot className="map-view-icon" />}
      {mode === "satellite" && <FaStreetView className="map-view-icon" />}
    </button>
  );
}

// Main MapControls component - EXACT same JSX from original Onde.jsx
const MapControls = ({ mapView, setMapView }) => {
  return (
    <div className="onde-map-controls">
      <ViewToggleButton
        mode={mapView}
        onToggle={() => setMapView(mapView === "map" ? "satellite" : "map")}
      />
      <CurrentLocationButton />
      <ZoomButtons />
    </div>
  );
};

export default MapControls;